<template>
  <div>
    <div class="ring-card-action-box grid gap-no">
      <div class="span-1">
        <img
            :src="icons.accountVerification"
            width="32">
      </div>

      <div class="span-8">
        <AccountVerificationPanel
            :expires-at="pii.authorization.expires_at"
            :is-approved-status="pii.authorization.status === 'active'"
            :is-verification-required="(!pii.authorization.status && backendAuthorizationStatus !== 'pending') || (backendAuthorizationStatus === 'pending' && !getStartedAt)"
            :is-pending="(pii.authorization.status || backendAuthorizationStatus === 'pending') && getStartedAt !== undefined"
            :status-message="statusMessage" />
      </div>

      <!-- Account verification buttons -->
      <div class="span-3 button-container">
        <div class="customer-field">
          <AccountVerificationButtons
              :is-verify-account-button-visible="!pii.authorization.status || pii.authorization.status === 'pending'"
              :is-verify-account-disabled="disableVerifyAccount"
              :is-verify-override-button-visible="hasOverrideAuthPermission"
              :on-close-action="fetchPIIAuthorization"
              :is-revoke-auth-button-visible="pii.authorization.status === 'active'" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { get } from "lodash";

import { createNamespacedHelpers as module } from "vuex";
import permission from "@/mixins/permission";
import TimeZoneFormatter from "@/helpers/TimeZoneFormatterHelper";
import AccountVerificationPanel from "../shared/AccountVerificationPanel";
import AccountVerificationButtons from "../shared/AccountVerificationButtons";

const { mapGetters: accountGetters } = module("db/account");

const {
  mapGetters: accountVerificationGetters,
  mapActions: accountVerificationActions,
} = module("db/account/verification");

const { mapActions: sharedActions } = module("shared");

export default {
  name: "RingAuthorizationForm",
  components: {
    AccountVerificationButtons,
    AccountVerificationPanel,
  },
  mixins: [permission],
  data() {
    return {
      icons: {
        accountVerification: require("@/assets/icons/action-account-verification.svg"),
      },
      revokeConfirmation: false,
      pii: {
        authorization: {
          status: "loading...",
        },
        ajax: {
          working: false,
        },
      },
      isAccountVerificationModalVisible: false,
      isAccountVerificationOverrideModalVisible: false,
      isAuthorizationRevokeModalVisible: false,
    };
  },
  computed: {
    ...accountGetters(["customerId", "isLocked"]),
    ...accountVerificationGetters([
      "getStartedAt",
      "getCurrentVerificationMethod",
      "getBackendAuthorizationStatus",
    ]),
    isAccountLocked() {
      return this.isLocked;
    },
    backendAuthorizationStatus() {
      return this.getBackendAuthorizationStatus;
    },
    disableVerifyAccount() {
      return (
        this.isAccountLocked ||
        (Boolean(this.pii.authorization.status) &&
          this.pii.authorization.status === "active")
      );
    },
    hasOverrideAuthPermission() {
      return this.hasPermission("Customer", "overrideAuth");
    },
    verticalAlignment() {
      return "column-centered";
    },
    statusMessage() {
      const formattedTime = TimeZoneFormatter.formattedTime(this.getStartedAt);

      if ("No Information" === formattedTime) {
        return "";
      }

      let message = "Passcode sent via SMS at [timestamp]";

      if (this.getCurrentVerificationMethod === "email") {
        message = "Passcode sent via Email at [timestamp]";
      } else if (this.getCurrentVerificationMethod === "ring_app_cc") {
        message = "Ring App verification started at [timestamp]";
      }

      return message.replace("[timestamp]", formattedTime);
    },
  },
  created() {
    this.fetchPIIAuthorization();
  },
  updated() {
    if (this.pii.authorization.status === "pending") {
      let input = document.getElementById("enterCode");
      if (input) {
        input.click();
      }
    }
  },
  methods: {
    ...sharedActions(["fetchPIIAuthorizationStatus"]),
    ...accountVerificationActions(["setBackendAuthorizationStatus"]),
    fetchPIIAuthorization() {
      this.pii.ajax.working = true;
      this.fetchPIIAuthorizationStatus()
        .then((response) => {
          this.pii.authorization = get(response, "data.authorization", {});
          this.setBackendAuthorizationStatus(
            get(this.pii, "authorization.status", "TimedOut")
          );
        })
        .catch((error) => console.error(error))
        .finally(() => (this.pii.ajax.working = false));
    },
  },
};
</script>

<style scoped>
.button-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
</style>
